import { Button, Card, Tag, Typography } from "@arco-design/web-react";

const { Title, Text } = Typography;

/** 最近动态记录。 */
export interface RecentActivityItem {
  time: string;
  type: string;
  tone: "arcoblue" | "green" | "orange";
  content: string;
  operator: string;
}

/** 最近动态表格。 */
export function RecentActivitiesTable({ items }: { items: RecentActivityItem[] }) {
  return (
    <Card
      bodyStyle={{ padding: 0 }}
      style={{
        border: "1px solid #e5e6eb",
        borderRadius: 20,
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "22px 24px",
          borderBottom: "1px solid #e5e6eb",
        }}
      >
        <Title heading={5} style={{ margin: 0 }}>
          最近动态
        </Title>
        <Button type="secondary" size="small">
          查看全部
        </Button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#fafafa" }}>
              {["时间", "类型", "内容", "操作人", "操作"].map((header) => (
                <th
                  key={header}
                  style={{
                    padding: "14px 18px",
                    textAlign: "left",
                    color: "#86909c",
                    fontSize: 13,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={`${item.time}-${item.content}`} style={{ borderTop: "1px solid #f2f3f5" }}>
                <td style={{ padding: "18px 18px", color: "#1d2129", whiteSpace: "nowrap" }}>
                  {item.time}
                </td>
                <td style={{ padding: "18px 18px", whiteSpace: "nowrap" }}>
                  <Tag color={item.tone}>{item.type}</Tag>
                </td>
                <td style={{ padding: "18px 18px", color: "#1d2129" }}>{item.content}</td>
                <td style={{ padding: "18px 18px", color: "#4e5969", whiteSpace: "nowrap" }}>
                  {item.operator}
                </td>
                <td style={{ padding: "18px 18px", whiteSpace: "nowrap" }}>
                  <Text
                    style={{
                      color: "#165dff",
                      cursor: "pointer",
                      fontWeight: 600,
                    }}
                  >
                    详情
                  </Text>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
